import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <>
      {/* Mobile Layout - Direct auth pages without layout wrapper */}
      <div className="lg:hidden min-h-screen bg-primary-500 flex items-center justify-center p-4">
        <div className="w-full max-w-md mx-auto">
          <Outlet />
        </div>
      </div>

      {/* Desktop Layout - Full layout with illustration */}
      <div className="hidden lg:flex min-h-screen flex-row">
        {/* Left Side - Login Form (Yellow Background) */}
        <div className="w-1/2 bg-primary-500 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>

        {/* Right Side - Branding & Illustrations (Light Gray Background) */}
        <div className="w-1/2 bg-gray-100 flex flex-col items-center justify-center p-8 relative">
          {/* Logo */}
          <div className="absolute top-8 left-1/2 transform -translate-x-1/2 z-10">
            <div className="flex items-center gap-3">
              <img 
                src="/img/logo.png" 
                alt="LogisHaus Logo" 
                className="h-10 w-auto"
              />
              <span className="text-2xl font-medium text-black">LogisHaus</span>
            </div>
          </div>

          {/* Auth Illustration */}
          <div className="flex items-center justify-center w-full h-full px-4">
            <img 
              src="/img/authanim.gif" 
              alt="Logistics Management Animation" 
              className="object-contain w-full max-w-[640px] h-auto"
              onError={(e) => {
                console.error('Failed to load authanim.gif, falling back to auth.svg');
                (e.target as HTMLImageElement).src = '/img/auth.svg';
              }}
              onLoad={() => {
                console.log('authanim.gif loaded successfully');
              }}
            />
          </div>

          {/* Tagline */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center px-4">
            <p className="text-lg font-medium text-black">
              Manage & Track Orders and Logistics
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
